module.exports = __webpack_public_path__ + "img/grid-2.266b7de3.svg";